// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import OneOffPaymentNS from './constants/OneOffPaymentNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, OneOffPaymentNS);
  const applyPayment = `applyPayment(input: ${dataCreate})`;
  return gql`
  mutation {
    ${applyPayment} {
      id
      accountId
      invoiceUnitId
      transactionId
      paymentDate
      arOpsPaymentId
      arOpsReversalId
      paymentSuspenseId
      status
      amount
      remainingAmount
      reversedAmount
      method
      paymentCreditCards {
        cardToken
        cardExpiry
        last4CC
        merchant
      }
      paymentInvoices{
        bank
        checkNumber
        routingNumber
      }
    }
  }
`;
};
